<template>
	<div id="app">
		<div v-if="maintenance === false">
			<ml-header></ml-header>
			<div id="content">
				<router-view/>
			</div>
			<ml-footer></ml-footer>
			<vue-progress-bar />
		</div>
		<div v-else class="text-center">
			<img width="100%" src="/assets/maintenance-milagros.jpg">
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';
	import { client } from '@/api/client';

	export default {
		data() {
			return {
				maintenance: false,
			}
		},
		computed: {
			...mapState(['pageTitle', 'progressStatus']),

			title() {
				return `${this.pageTitle} - Milagros Mobile Counter`;
			},
		},
		watch: {
			pageTitle(val, oldVal) {
				if (val !== oldVal) {
					document.title = this.title;
				}
			},

			progressStatus(val, oldVal) {
				if (val !== oldVal) {
					switch (val) {
						case 'start':
						this.$Progress.start();
						break;
						case 'fail':
						this.$Progress.fail();
						break;
						default:
						this.$Progress.finish();
						break;
					}
				}
			},
		},
		methods: {
			...mapActions('auth', ['logout']),
			...mapActions('maps', ['getGeolocation']),

			forceLogout() {
				this.logout().then(() => {
					this.$router.push({ name: 'login' });
				});
			},
			maintenancePage() {
				this.logout().then(() => {
					this.maintenance = true
					// this.$router.push({ name: 'maintenance' });
				});
			},
		},
		created: function () {
			client.interceptors.response.use(undefined, (error) => {
				return new Promise(() => {
					if (error.response.status  == 406) {
						this.forceLogout()
					}
					if (error.response.status  == 503) {
						this.maintenancePage()
					}
					throw error
				})
			});

			this.getGeolocation()
		}
	};
</script>

<style>
.caraousel-index > .owl-carousel {
	height: 100% !important;
}
</style>

<style lang="scss">
@import "~bootstrap/scss/bootstrap";
@import "./styles/variables";
@import "./styles/app";
@import "./styles/custom";
@import "./styles/responsive";

</style>

